import styles from './Page.module.css';
import React, { useState, useEffect } from 'react';

function RevDupPage() {
  // const [documents, setDocuments] = useState([]);
  const [isSaving, setIsSaving] = useState(false);
  const [newsList, setNewsList] = useState([]);
  const [documentsForBase, setDocumentsForBase] = useState([]);
  const [lastDocumentToBase, setLastDocumentToBase] = useState(0);

  useEffect(() => {
    async function fetchData() {
      const response = await fetch('/api/reviews/forrevduplicatesnewslist');
      const data = await response.json();
      console.log('data');
      console.log(data);

      if (data) {
        setNewsList(data);
        setDocumentsForBase(
          data.map((document) => ({
            ...document,
            similarities: document.similarities && document.similarities.length
              ? [document.similarities[0]]
              : [],
          }))
        );
      }
    }
    fetchData();
  }, []);
  


function handleSimilarityClick(docIndex, simId, simIndex) {
  // create a copy of the clonedDocuments array
  const newClonedDocuments = [...documentsForBase];
  const similarityExists = newClonedDocuments[docIndex].similarities.some(
    (similarity) => similarity._id === simId
  );
  if (similarityExists) {
    // remove the similarity from the clonedDocuments array
    newClonedDocuments[docIndex].similarities = newClonedDocuments[docIndex].similarities.filter(
      (similarity) => similarity._id !== simId
    );
  } else {
    // add the similarity to the clonedDocuments array
    newClonedDocuments[docIndex].similarities.push(newsList[docIndex].similarities[simIndex]);
  }

  // update the state with the new clonedDocuments array
  setDocumentsForBase(newClonedDocuments);
  if (docIndex > lastDocumentToBase) {
    setLastDocumentToBase(docIndex);
  }
}

const handleSave = async () => {
  setIsSaving(true);
  const reviewedNews = documentsForBase.slice(0, lastDocumentToBase+1);
  reviewedNews.forEach(function(item) {
    if (item.similarities.length) {
      item.stage = "not_publish_is_duplicate";
    } else {
      item.stage = "for_importance_review";
    }
  });
  if (reviewedNews.length > 0) {
    try {
      await  fetch('/api/reviews/duplicatesreviewednewstobase', {
        method: 'POST',
        body: JSON.stringify(reviewedNews),
        headers: {
          'Content-Type': 'application/json'
        }
      })
      .then(response => {
        // Обробка відповіді сервера
      })
      .catch(error => {
        // Обробка помилки
      });
      setIsSaving(false);
      setLastDocumentToBase(0);
      const response = await fetch('/api/reviews/forrevduplicatesnewslist');
      const data = await response.json();
      const filteredNewsList = data.filter(item => item.similarities.length > 0);

      setNewsList(filteredNewsList);
      setDocumentsForBase(data.map((document) => ({ ...document, similarities: [document.similarities[0]] })));
    } catch (error) {
      console.error(error);
      setIsSaving(false);
    }

  }
  setIsSaving(false);
};

return (
  <div className={styles.root}>
    {newsList.length > 0 && documentsForBase.length > 0 && newsList.every(doc => doc.similarities && doc.similarities.length > 0) 
    // && documentsForBase.every(doc => doc.similarities && doc.similarities.length > 0) 
    && (
      <>
        <button onClick={handleSave} disabled={isSaving} style={{ position: "fixed", top: 0 }}>
          {isSaving ? "Saving..." : "Save similarity News"}
        </button>      
        {newsList.map((document, docIndex) => (
          <div key={document.id} className={styles.document}>
            <h2 className={styles.title}>
              {document.title} (<a href={document.url} target="_blank">відкрити</a>)
            </h2>
            {document.similarities.sort((a, b) => b.similarityValue - a.similarityValue).map((similarityOriginal, simIndex) => (
              <div>                
                <button 
                  key={similarityOriginal._id}
                  className={documentsForBase[docIndex].similarities.some((similarity) => similarity._id === similarityOriginal._id) ? styles.active : ""}
                  onClick={() => handleSimilarityClick(docIndex, similarityOriginal._id, simIndex)}
                >
                  {similarityOriginal.title} ({similarityOriginal.similarityValue})
                </button>
                (<a href={similarityOriginal.url} target="_blank">відкрити</a>)
              </div>
            ))}
          </div>
        ))}
      </>
    )}
  </div>
);

}

export default RevDupPage;
